"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentActions = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var file_1 = require("../../providers/file");
function AttachmentActions(props) {
    var attachment = props.attachment, onClick = props.onClick;
    var removeAttachmentTestId = "".concat(attachment.filename, "-remove");
    var redirect = (0, file_1.useFileDetailsContext)().redirect;
    function onRedirect(event) {
        event.preventDefault();
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        redirect(true);
    }
    return (react_1.default.createElement(StyledActions, null,
        react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center" },
            react_1.default.createElement(core_ui_1.IconButton, { type: "external", onClick: function (e) { return onRedirect(e); } }),
            react_1.default.createElement(core_ui_1.IconButton, { type: "close", testId: removeAttachmentTestId, onClick: function (e) {
                    e.preventDefault();
                    onClick();
                } }))));
}
exports.AttachmentActions = AttachmentActions;
var StyledActions = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  right: 16px;\n  top: 16px;\n"], ["\n  position: absolute;\n  right: 16px;\n  top: 16px;\n"])));
var templateObject_1;
